import React, { useState, useEffect } from "react";
import Measure from "react-measure";
import { removeParamsFromUrl } from "../functions";
import config from "lib/config";
import { COURSE_TYPE_ONLINE, PARAMS_TO_REMOVE } from "../constants";
import { Grid } from "Components/Base/Layout/Grid";
import { TextField } from "Components/Base/Inputs/TextField";
import { IconButton } from "Components/Base/Inputs/IconButton";
import { Button } from "Components/Base/Inputs/Button";
import { MailIcon } from "Components/Icons";

const ShareCourseContentLink = (props) => {
  const {
    languageContext,
    subject,
    objectId = 0,
    isRatingPopup = false,
    objectType,
  } = props;
  const [url, setUrl] = useState(removeParamsFromUrl(PARAMS_TO_REMOVE));

  const [dimensions, setDimensions] = useState({ width: 1024, height: 768 });
  const updateDimensions = (d) => {
    setDimensions(d);
  };

  const copyToClipboard = () => navigator.clipboard.writeText(url);

  const [body, setBody] = useState(
    encodeURIComponent(languageContext("sharecoursemailbody")) +
      " " +
      encodeURIComponent(subject) +
      encodeURIComponent("\r") +
      encodeURIComponent(removeParamsFromUrl(PARAMS_TO_REMOVE)),
  );

  useEffect(() => {
    if (isRatingPopup && objectId && objectType) {
      if (objectType === COURSE_TYPE_ONLINE) {
        const onlineCourseDetailUrl = `${window.location.origin}${config.urlRoot}activities/onlinecoursedetails.aspx?inapp=1&courseid=${objectId}&regionid=0&cityid=0&fromdate=&todate=`;

        setUrl(onlineCourseDetailUrl);
        setBody(
          encodeURIComponent(languageContext("sharecoursemailbody")) +
            " " +
            encodeURIComponent(subject) +
            encodeURIComponent("\r") +
            encodeURIComponent(onlineCourseDetailUrl),
        );
      }
      if (objectType !== COURSE_TYPE_ONLINE) {
        const nonOnlineCourseDetailUrl = `${window.location.origin}${config.urlRoot}activities/ActivityDetails.aspx?inapp=1&id=${objectId}&regionid=0&cityid=0&fromdate=&todate=`;

        setUrl(nonOnlineCourseDetailUrl);
        setBody(
          encodeURIComponent(languageContext("sharecoursemailbody")) +
            " " +
            encodeURIComponent(subject) +
            encodeURIComponent("\r") +
            encodeURIComponent(nonOnlineCourseDetailUrl),
        );
      }
    }
  }, []);

  const updateUrl = (newUrl) => {
    setUrl(newUrl);
    setBody(
      encodeURIComponent(languageContext("sharecoursemailbody")) +
        " " +
        encodeURIComponent(subject) +
        encodeURIComponent("\r") +
        encodeURIComponent(newUrl),
    );
  };

  return (
    <Measure onMeasure={updateDimensions}>
      <div
        className={
          dimensions.width < 500
            ? "flex column width-100"
            : "flex flex-space-b align-c width-100"
        }
      >
        <Grid container spacing={1} alignItems="center">
          <Grid item>
            <TextField
              value={url}
              onChange={(e) => updateUrl(e.target.value)}
            />
          </Grid>
          <Grid item>
            <Button
              label={languageContext("tlpCopy")}
              onClick={copyToClipboard}
            />
          </Grid>
        </Grid>
        <div className={dimensions.width < 500 ? "flex margin-t-10" : "flex"}>
          <IconButton
            title={languageContext("sendemail")}
            icon={<MailIcon />}
            href={"mailto:abc@def.com?subject=" + subject + "&body=" + body}
          />
        </div>
      </div>
    </Measure>
  );
};

export default ShareCourseContentLink;
